/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { gql } from '@apollo/client';

export const MAKE_SINGLE_PAYMENT_MUTATION = gql`
  mutation makePaymentWebsite($update: PaymentInput) {
    makePaymentWebsite(update: $update) {
      success
      ccPaymentReceipt {
        transactionDate
        settlementDate
        amount
        receipt
      }
      failureReason {
        apiStatus
        apiTimestamp
        failureCode
        failureReason
      }
    }
  }
`;

/** The PayPal RDTO */
export type PayPalResultDTO = {
  getPaypalResponseWebsite: {
    accountNumber?: string;
    transactionDateTime?: Date;
    receipt?: string;
    paypalTrnID?: string;
  };
};

export const GET_PAYPAL_RESPONSE = gql`
  query GetPaypalResponseWebsite($sessionID: String!, $secureSessionToken: String!) {
    getPaypalResponseWebsite(sessionID: $sessionID, secureSessionToken: $secureSessionToken) {
      accountNumber
      transactionDateTime
      receipt
      paypalTrnID
    }
  }
`;
export const MAKE_SINGLE_PAYMENT_MUTATION_STRIPE = gql`
  mutation makeWebStripePayment($update: PaymentInputForStripe) {
    makeWebStripePayment(update: $update) {
      success
      clientSecret
      requiresAction
      ccPaymentReceipt {
        transactionDate
        settlementDate
        amount
        receipt
      }
      failureReason {
        apiStatus
        apiTimestamp
        failureCode
        failureReason
      }
    }
  }
`;
export const GET_RECEIPT_NUMBER = gql`
  query GetReceiptNumberWeb($paymentIntentId: String!, $accountNumber: String!) {
    getReceiptNumberWeb(paymentIntentId: $paymentIntentId, accountNumber: $accountNumber) {
      receiptNumber
    }
  }
`;
export const GENERATE_PAYPAL_ORDER_ID_WEB = gql`
  mutation GeneratePaypalOrderIdWeb($input: PaypalInput!) {
    generatePaypalOrderIdWeb(input: $input) {
      orderId
      status
      success
      message
      approvalUrl
      captureId
    }
  }
`;
export const GENERATE_PAYPAL_CAPTURE_ORDER_WEB = gql`
  mutation GeneratePaypalCaptureOrderWeb($input: PaypalCaptureInput!) {
    generatePaypalCaptureOrderWeb(input: $input) {
      orderId
      status
      success
      message
      approvalUrl
      captureId
    }
  }
`;
interface GeneratePaypalOrderIdWeb {
  orderId: string;
  status: boolean;
  success: boolean | null;
  message: string;
  approvalUrl: string;
  captureId: string | null;
}
export interface GeneratePaypalOrderIdWebResponse {
  generatePaypalOrderIdWeb: GeneratePaypalOrderIdWeb;
}
export const setAccountNumberLocal = (accountNumber: string) => {
  localStorage.setItem('accountNumber', accountNumber);
};

export const getAccountNumber = (): string | null => {
  return localStorage.getItem('accountNumber');
};
export const clearLocalStore = () => {
  localStorage.removeItem('accountNumber');
  localStorage.removeItem('amount');
};
export const setAmountLocal = (amount: string) => {
  localStorage.setItem('amount', amount);
};

export const getAmountLocal = (): string | null => {
  return localStorage.getItem('amount');
};

export const LOG_APP_INSIGHT = gql`
  mutation LogAppInsight($input: AppInsightLogInput!) {
    logAppInsight(input: $input)
  }
`;

export interface AppInsightParams {
  paymentType: string;
  accountNumber: string;
  status: number;
  message: string;
}
export interface AppInsightInput {
  params: AppInsightParams;
}

export interface LogAppInsightResponse {
  logAppInsight: boolean;
}
